// extracted by mini-css-extract-plugin
export default {"normal":"kP01rb","roman":"wXaB35","bold":"I7NmKh"};